export function compareReviews(a, b) {
  return b.rating - a.rating
    || Number(b.verified) - Number(a.verified)
    || b.bodyLength - a.bodyLength
    || b.date - a.date
    || a.originalIndex - b.originalIndex;
}

export function visiblePages(current, total) {
  const pages = [];
  for (let page = 1; page <= total; page += 1) {
    if (page === 1 || page === total || Math.abs(page - current) <= 1) {
      if (pages.length && page - pages.at(-1) > 1) pages.push('…');
      pages.push(page);
    }
  }
  return pages;
}

export function reviewPage(items, page, pageSize) {
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const current = Math.min(Math.max(1, page), totalPages);
  const start = (current - 1) * pageSize;
  return {current, totalPages, items: items.slice(start, start + pageSize)};
}

export function reviewPageHref(currentHref, page) {
  const url = new URL(currentHref);
  url.searchParams.set('reviews_page', String(page));
  url.hash = 'reviews-list';
  return url.href;
}

export function pageArrows(rtl) {
  return rtl ? {previous: '→', next: '←'} : {previous: '←', next: '→'};
}

function pageControl(tag, content, label, page, disabled = false) {
  const node = document.createElement(tag);
  node.textContent = content;
  node.setAttribute('aria-label', label);
  if (disabled) node.setAttribute('aria-disabled', 'true');
  if (tag === 'a') node.href = reviewPageHref(window.location.href, page);
  return node;
}

function renderPagination(list, count, currentPage) {
  const nav = list.querySelector('[data-vera-review-pagination]');
  if (!nav) return;
  const totalPages = Math.ceil(count / 6);
  nav.hidden = totalPages <= 1;
  if (nav.hidden) return;

  const rtl = getComputedStyle(list).direction === 'rtl';
  const arrows = pageArrows(rtl);
  const previousLabel = list.dataset.previousLabel;
  const nextLabel = list.dataset.nextLabel;
  const pageLabel = list.dataset.pageLabel;
  const previous = pageControl(currentPage === 1 ? 'span' : 'a', arrows.previous, previousLabel, currentPage - 1, currentPage === 1);
  const next = pageControl(currentPage === totalPages ? 'span' : 'a', arrows.next, nextLabel, currentPage + 1, currentPage === totalPages);
  nav.append(previous);

  for (const page of visiblePages(currentPage, totalPages)) {
    if (page === '…') {
      const ellipsis = document.createElement('span');
      ellipsis.textContent = '…';
      ellipsis.setAttribute('aria-hidden', 'true');
      nav.append(ellipsis);
      continue;
    }
    const label = pageLabel.replace('[page]', String(page));
    const item = pageControl(page === currentPage ? 'span' : 'a', String(page), label, page);
    if (page === currentPage) item.setAttribute('aria-current', 'page');
    nav.append(item);
  }
  nav.append(next);
}

export function initializeReviewList(list) {
  const grid = list.querySelector('[data-vera-review-grid]');
  if (!grid) return;
  const reviews = Array.from(grid.children).map((element, originalIndex) => ({
    element,
    originalIndex,
    rating: Number(element.dataset.reviewRating) || 0,
    verified: element.dataset.reviewVerified === '1',
    bodyLength: element.querySelector('[data-review-body]')?.textContent.replace(/\s+/g, ' ').trim().length || 0,
    date: Date.parse(element.dataset.reviewDate || '') || 0,
  }));
  reviews.sort(compareReviews);
  grid.replaceChildren(...reviews.map(({element}) => element));

  const full = list.dataset.viewMode === 'full';
  const pageSize = full ? 6 : 4;
  const requested = Number(new URL(window.location.href).searchParams.get('reviews_page'));
  const page = reviewPage(reviews, full && Number.isInteger(requested) ? requested : 1, pageSize);
  const currentPage = page.current;
  const start = (currentPage - 1) * pageSize;
  reviews.forEach(({element}, index) => {
    element.hidden = index < start || index >= start + pageSize;
  });
  grid.setAttribute('data-ready', '');
  if (full) {
    renderPagination(list, reviews.length, currentPage);
    if (window.location.search.includes('reviews_page=') || window.location.hash === '#reviews-list') {
      requestAnimationFrame(() => list.scrollIntoView({block: 'start'}));
    }
  }
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-vera-review-list]').forEach(initializeReviewList);
}
